/* eslint-disable prefer-const */
/* eslint-disable prefer-destructuring */
import React, { useContext, useEffect, useReducer } from 'react';
import { CLEAR_FILTERS, FILTER_PRODUCTS, LOAD_PRODUCTS, SET_GRIDVIEW, SET_LISTVIEW, SORT_PRODUCTS, UPDATE_FILTERS, UPDATE_SORT } from '../actions';
import reducer from '../reducers/filterReducer';
// import {LOAD_PRODUCTS, SET_GRIDVIEW, SET_LISTVIEW, UPDATE_SORT, SORT_PRODUCTS, UPDATE_FILTERS, FILTER_PRODUCTS, CLEAR_FILTERS} from '../actions';
import { useProductsContext } from './productsContext';

const initialState = {
   filteredProducts: [],
   allProducts: [],
   gridView: true,
   sort: 'price-lowest',
   filters: {
      text: '',
      company: 'all',
      category: 'all',
      color: 'all',
      minPrice: 0,
      maxPrice: 0,
      price: 0,
      shipping: false
   }
};

const FilterContext = React.createContext();

export const FilterProvider = ({children}) => {
   const {products} = useProductsContext();
   const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(() => {
      dispatch({type: LOAD_PRODUCTS, payload: products})
   }, [products])

   useEffect(() => {
      dispatch({type: FILTER_PRODUCTS})
      dispatch({type: SORT_PRODUCTS})
      
   }, [products, state.sort, state.filters]);

   const setGridView = () => {
      dispatch({type: SET_GRIDVIEW})
   }

   const setListView = () => {
      dispatch({type: SET_LISTVIEW})
   }

   const updateSort = (e) => {
      // const name = e.target.name;
      const {value} = e.target;
      dispatch({type: UPDATE_SORT, payload: value})
   }

   const updateFilters = (e) => {
       let name = e.target.name;
       let value = e.target.value;

       // get value frpm button
       if (name === 'category') {
          value = e.target.textContent;
       }

       if (name === 'color') {
          value = e.target.dataset.color
       }

       if (name === 'price'){
          value = Number(value)
       }

       if (name === 'shipping') {
          value = e.target.checked
       }
 
       dispatch({type: UPDATE_FILTERS, payload: {name, value}})
   }

   const clearFilters = () => {
      dispatch({type:  CLEAR_FILTERS})
   }

   return (
      <FilterContext.Provider value={ {...state, setGridView, setListView, updateSort, updateFilters, clearFilters} }>
         {children}
      </FilterContext.Provider>
   )
}

export const useFilterContext = () => useContext(FilterContext)